import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { normalizeDateForServer } from '../utils/date';

export const fetchMilestones = ({ projectId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'milestones',
        params: {
            project_id: projectId,
            offset,
            limit
        }
    })
    .then(response => ({
        ...response.data,
        items: validateResponse(response, 'items').data.items.map(milestone => ({
            ...milestone,
            start: new Date(milestone.start).getTime(),
            end: new Date(milestone.end).getTime()
        }))
    }))
    .catch(handleServerError);
}

export const createMilestone = ({ project, task_group, name, description, start, end, dependency, hidden, isTaskGroup }) => {
    return AjaxService({
        method: 'post',
        url: 'milestones',
        data: {
            project_id: project,
            task_group_id: task_group,
            name,
            description: description || undefined,
            start: normalizeDateForServer(start),
            end: normalizeDateForServer(end),
            dependency: dependency ? dependency : undefined,
            hidden,
            isTaskGroup
        }
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const fetchMilestone = milestoneId => {
    return AjaxService({
        method: 'get',
        url: `milestones/${milestoneId}`
    })
    .then(({ data }) => ({
        ...data,
        start: new Date(data.start).getTime(),
        end: new Date(data.end).getTime()
    }));
}

export const updateMilestone = (milestoneId, { name, description, start, end, dependency, archived }) => {
    if (typeof archived !== 'undefined') {
        return archiveMilestone(milestoneId, { archived });
    }

    return AjaxService({
        method: 'put',
        url: `milestones/${milestoneId}`,
        data: {
            name,
            description,
            start: normalizeDateForServer(start),
            end: normalizeDateForServer(end),
            dependency
        }
    })
    .then(({ data }) => ({
        ...data,
        start: new Date(data.start).getTime(),
        end: new Date(data.end).getTime()
    }))
    .catch(handleServerError);
}

export const archiveMilestone = (milestoneId, { archived }) => {
    return AjaxService({
        method: 'post',
        url: `milestones/${milestoneId}/archive`,
        data: {
            archived
        }
    })
    .then(({ data }) => ({
        ...data
    }))
    .catch(handleServerError);
}

export const removeMilestone = milestoneId => {
    return AjaxService({
        method: 'delete',
        url: `milestones/${milestoneId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const setVisibility = (milestoneId, visible, roles) => {
    return AjaxService({
        method: 'post',
        url: `milestones/${milestoneId}/${visible ? 'reveal' : 'hide'}`,
        data: { roles }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const tieTasks = (milestoneId, tasks) => {
    return AjaxService({
        method: 'put',
        url: `milestones/${milestoneId}/tasks`,
        data: { tasks }

    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const untieTasks = (milestoneId, tasks) => {
    return AjaxService({
        method: 'delete',
        url: `milestones/${milestoneId}/tasks`,
        data: { tasks }

    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const duplicateMilestone = milestoneId => {
    return AjaxService({
        method: 'post',
        url: `milestones/${milestoneId}/clone`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
